import React from "react";
import { CheckIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { heroBullets } from "../../data/landing";
import { MOCKUP_URL, PRODUCT_NAME } from "../../data/offer";
export function Hero() {
  return <header className="bg-sky-soft" data-id="element-188" data-mp="cu9ski4wh0rd">
      <div className="bg-navy px-4 py-2.5 text-center text-[13px] font-extrabold uppercase tracking-wide text-white sm:text-sm" data-id="element-189" data-mp="huxs5s772px7">
        <span className="text-sun" data-id="element-190" data-mp="muty3wzgcrfe">Promotional launch offer</span> · Complete collection for just $27
      </div>

      <div className="mx-auto grid max-w-6xl gap-8 px-4 pb-16 pt-8 sm:px-6 md:grid-cols-[1.05fr_1fr] md:items-center md:gap-12 md:pb-24 md:pt-16" data-id="element-191" data-mp="qukldqprspf6">
        <div className="contents md:block" data-id="element-192" data-mp="vootweeop5id">
          <div className="order-1" data-id="element-193" data-mp="10kdtuium8of7">
            <p className="font-display text-[15px] font-bold uppercase tracking-wide text-sky" data-id="element-194" data-mp="10njki2iw7yd1">
              {PRODUCT_NAME}
            </p>
            <p className="mt-1 text-sm font-bold text-ink/70" data-id="element-195" data-mp="1aj3doh62oiy3">A more organized approach to pediatric speech sound planning</p>
            <h1 className="mt-3 text-balance font-display text-[38px] font-bold leading-[1.05] text-navy sm:text-5xl md:text-[56px]" data-id="element-196" data-mp="9oueicg09o3u">
              Stop starting from scratch when planning your next{" "}
              <span className="text-coral" data-id="element-197" data-mp="3vvsmh63jwlk5">articulation session.</span>
            </h1>
          </div>

          <div className="order-3 md:mt-6" data-id="element-198" data-mp="3ruqrx2kkwxoi">
            <p className="text-lg leading-relaxed text-ink/85" data-id="element-199" data-mp="seanzp9o4qwe">
              Bring your speech sound observations, activity ideas, session planning worksheets, and progress
              documentation together in one practical educational collection.
            </p>
            <p className="mt-3 text-[17px] leading-relaxed text-ink/80" data-id="element-200" data-mp="imo7peih41ms">
              Includes <strong className="text-navy" data-id="element-201" data-mp="em46nzus4dvd">six practical volumes</strong> and{" "}
              <strong className="text-navy" data-id="element-202" data-mp="1b5tqzw3p04yf">five specialized bonuses</strong> designed to help speech-language
              pathologists organize their work with children who have speech sound difficulties.
            </p>

            <p className="mt-6 font-display text-lg font-semibold text-navy" data-id="element-203" data-mp="30mfj7x7ns1ha">Inside, you'll find:</p>
            <ul className="mt-3 space-y-2.5" data-id="element-204" data-mp="35kgz699sfkoj">
              {heroBullets.map(b => <li key={b} className="flex items-start gap-3 text-[16px] font-semibold leading-snug text-ink" data-id="element-205" data-mp="2qvcg6pv65cfd">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-mint text-white" data-id="element-206" data-mp="2vte2djnw5rv2">
                    <CheckIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-207" data-mp="2muive5d0wdqp" />
                  </span>
                  {b}
                </li>)}
            </ul>

            <div className="mt-8 rounded-3xl bg-white p-5 shadow-[0_10px_30px_rgba(15,37,87,0.08)] ring-1 ring-navy/5 sm:p-6" data-id="element-208" data-mp="27zcl366w9srk">
              <p className="text-center font-display text-lg font-semibold text-navy" data-id="element-209" data-mp="6650bh8iiiya">
                Get the complete Blueprint for just
              </p>
              <div className="mt-1 flex items-end justify-center gap-3" data-id="element-210" data-mp="b46ryqk07qld">
                <span className="pb-2 text-xl font-extrabold text-ink/50 line-through" data-id="element-211" data-mp="1vnsewiyy2oe6">$203</span>
                <span className="font-display text-6xl font-bold leading-none text-coral" data-id="element-212" data-mp="1qoz3cw37x7gn">$27</span>
                <span className="pb-2 text-sm font-extrabold uppercase text-ink/70" data-id="element-213" data-mp="25dlq3iv6d1hw">USD</span>
              </div>
              <div className="mt-5" data-id="element-214" data-mp="20kivd7envm04">
                <CTAButton id="first-cta" label="Get instant access now" note="Digital educational resource · One-time payment · Instant digital access" data-id="element-215" data-mp="2edi8j2qz144i" />
              </div>
            </div>
          </div>
        </div>

        <div className="order-2 md:order-2" data-id="element-216" data-mp="2o9bs3633xxvs">
          <div className="-mx-4 bg-white p-3 sm:mx-0 sm:rounded-[28px] sm:p-5 sm:shadow-[0_20px_50px_rgba(15,37,87,0.12)]" data-id="element-217" data-mp="2jdmqyybfw8xd">
            <img src={MOCKUP_URL} alt="Pediatric Articulation Clinical Blueprint: six volumes and five bonus books with worksheets and picture cards" className="h-auto w-full" data-id="element-218" data-mp="ty6rkanbi1ko" />
          </div>
        </div>
      </div>
    </header>;
}